<template>
  <div>
    <div class="mainbg">
      <sec-carousel></sec-carousel>
    </div>
    <div class="mainbgTwo"><img src="../assets/images/news/mainbgTwo.jpg" alt=""></div>
    <div class="container">
        <div class="row rowwarp">
            <div class="rowwpRight">
                <div class="itemtop">
                    <img src="../assets/images/news/brnav_home.png" alt="">
                    <span><a href="javascript:void(0);" @click="returnBack">   首页</a></span>
                    <span>&gt;</span>
                    <span><a href="javascript:void(0);">站点地图</a></span>
                </div>
                <div class="box" v-loading="loading">
                    <div class="content" v-html="htmlCont" >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as utils from '../utils.js'
import * as api from '../api/api.js'
import SecCarousel from './secCarousel'
export default {
  components: {
    SecCarousel
  },
  data () {
    return {
      htmlCont: '',
      loading: false
    }
  },
  watch: {
    '$route': function (val) {
      this.init()
    }
  },
  created () {
    this.init ()
  },
  methods: {
    // 返回首页
    returnBack(){
      this.$router.push({path: '/'})
    },
    init: function () {
      this.getContent()
    },
    getContent: function () {
      let param = {
        igid: this.$route.params.igid,
        key: this.$route.params.key + '_cont'
      }
      this.loading = true
      this.htmlCont = ''
      api.getContent(param).then((res) => {
        this.loading = false
        if (res.Status === 100) {
          if(res.Data ==='' || res.Data === undefined || res.Data ===null){
            this.htmlCont='暂无数据'
          }else {
            let curHtml = JSON.parse(res.Data.Value).curHtml
            curHtml = curHtml.replace(/src=\"static\/js\/plugins\/bdmap\/bd.html/g, 'src="http://' + window.location.host + '/static/js/plugins/bdmap/bd.html')
            curHtml = curHtml.replace(/static\/tinymce\/skins\/icons\//g, 'http://' + window.location.host + '/static/tinymce/skins/icons/')
            this.htmlCont = curHtml
          }
        }
      })
    },
    getBtn: function (item) {
      console.log(item.Key)
      if(this.$route.params.key !==item.Key){
        if (item.Key === 'development') {
          this.$router.push({name: 'news', params: {fkey: this.$route.params.fkey, key: item.Key}})
        } else {
          this.$router.push({name: 'info', params: {fkey: this.$route.params.fkey, key: item.Key}})
        }
      }
    }
  }
}
</script>
<style>
  .attachment img {
    height: 30px;
    width: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/siteMap.vue